module.exports = __webpack_public_path__ + "img/room-2.738266e0.jpg";